import { render, staticRenderFns } from "./CustomerOptions.vue?vue&type=template&id=40bb4e4c&scoped=true&"
import script from "./CustomerOptions.vue?vue&type=script&lang=js&"
export * from "./CustomerOptions.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOptions.vue?vue&type=style&index=0&id=40bb4e4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb4e4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40bb4e4c')) {
      api.createRecord('40bb4e4c', component.options)
    } else {
      api.reload('40bb4e4c', component.options)
    }
    module.hot.accept("./CustomerOptions.vue?vue&type=template&id=40bb4e4c&scoped=true&", function () {
      api.rerender('40bb4e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Trips/Components/CustomerOptions.vue"
export default component.exports